import script from "./ModalCampaignEnded.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCampaignEnded.vue?vue&type=script&setup=true&lang=js"

import "./ModalCampaignEnded.vue?vue&type=style&index=0&id=6b5a6b19&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5a6b19"]])

export default __exports__